<template>
    <table id="siteTable" v-if="!reloaded">
        <thead>
            <tr>
                <th class="fixedTateYoko" rowspan="2" width="3%" v-if="dateUnit === 'day'">日付</th>
                <th class="fixedTateYoko" rowspan="2" width="3%" v-if="dateUnit === 'week'">週</th>
                <th class="fixedTateYoko" rowspan="2" width="3%" v-if="dateUnit === 'month'">年月</th>


                <th class="fixedYoko" :colspan="serviceColList[1]" width="7.5%">合計</th>


                <!-- 自社名称（services.jsから取得） -->
                <template v-for="service in services.inHouses">
                    <th class="fixedYoko" :colspan="serviceColList[service.no]" width="7.5%" :key="service.id">{{
                        service.name }}
                    </th>
                </template>


                <!-- モール名称（services.jsから取得） -->
                <template v-for="mallService in services.malls">
                    <!-- 楽天の場合、全店集計と各店舗集計をタブ切り替えで表示 -->
                    <template v-if="mallService.id == 'rakuten'">
                        <!-- タブ非展開 -->
                        <template v-if="!deploymented">
                            <th class="fixedYoko" :colspan="serviceColList[mallService.no]" width="7.5%"
                                :key="mallService.id">
                                {{ mallService.name }}
                                <span class="shrinkBtn" @click="deploymentedDisp"></span>
                            </th>
                        </template>
                        <!-- タブ展開 -->
                        <template v-else>
                            <template v-for="service in mallService.services">
                                <th class="fixedYoko" :colspan="serviceColList[service.no]" width="7.5%"
                                    :key="service.id">
                                    {{ service.name }}({{ mallService.name }})
                                    <span
                                        v-if="mallService.services.slice(-1)[0] == service && mallService.services.length > 1"
                                        class="shrinkBtn" @click="deploymentedDisp"></span>
                                </th>
                            </template>
                        </template>
                    </template>
                    <!-- 楽天以外の場合 -->
                    <template v-else>
                        <template v-for="service in mallService.services">
                            <th class="fixedYoko" :colspan="serviceColList[service.no]" width="7.5%" :key="service.id">
                                {{ service.name }}({{ mallService.name }})
                            </th>
                        </template>
                    </template>
                </template>


                <!-- 店舗名称（services.jsから取得） -->
                <template v-for="shopService in filteredShops">
                    <!-- タブ非展開 -->
                    <template v-if="!deploymented">
                        <th class="fixedYoko" :colspan="serviceColList[shopService.no]" width="7.5%"
                            :key="shopService.id">
                            {{ shopService.name }}
                            <span class="shrinkBtn" @click="deploymentedDisp"></span>
                        </th>
                    </template>
                    <!-- タブ展開 -->
                    <template v-else>
                        <template v-for="service in shopService.services">
                            <th class="fixedYoko" :colspan="serviceColList[service.no]" width="7.5%" :key="service.id">
                                {{ service.name }}
                                <span
                                    v-if="shopService.services.slice(-1)[0] == service && shopService.services.length > 1"
                                    class="shrinkBtn" @click="deploymentedDisp"></span>
                            </th>
                        </template>
                    </template>
                </template>
            </tr>
            <tr>
                <template v-for="(no, idx) in serviceNoOrder">
                    <!-- 合計列のROAS -->
                    <template v-if="idx === 0">
                        <th class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-roas`">
                            <span class="header-label">
                                全体ROAS<span class="shrinkBtn" @click="roasDisp(1)"></span>
                            </span>
                        </th>
                        <th v-if="roasTab" class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-ecroas`">
                            EC ROAS
                        </th>
                    </template>
                    <!-- 合計列以外のROAS -->
                    <template v-else>
                        <th class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-roas`">ROAS</th>
                    </template>

                    <th class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-earnings`">
                        <span class="header-label">
                            売上<span class="shrinkBtn" @click="comparedDisp(no)"></span>
                        </span>
                    </th>
                    <th v-if="comparedTabList[no]" class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-lastYearEarnings`">
                        前年売上
                    </th>

                    <th class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-quantity`">数量</th>
                    <th class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-cost`">広告費</th>

                    <th v-if="comparedTabList[no]" class="fixedYokoTwo fixedYokoTwo_s" :key="`${no}-lastYearCost`">
                        前年広告費
                    </th>
                </template>
            </tr>
        </thead>


        <tbody>
            <tr v-for="(output, monthOrday) in dispReports" :key="monthOrday" class="selectRoasRow">
                <!-- 日付 -->
                <td class="fixedTate dayField" :class="dayFieldColorClass(monthOrday)">{{ monthOrday }}</td>

                <template>
                    <!-- 合計(ROAS･売上･数量･広告費) -->
                    <td>{{ maskRowRoas(monthOrday, output["roas"]["allServiceRoas"]) | percentDisp }}</td>
                    <td v-if="roasTab">{{ maskRowRoas(monthOrday, output["roas"]["ecServiceRoas"]) | percentDisp }}</td>
                    <td>{{ output["roas"]["allServiceEarnings"] | priceLocaleString }}</td>
                    <td v-if="comparedTabList[1]">{{ output["roas"]["allServiceLastYearEarnings"] | priceLocaleString }}
                    </td>
                    <td>{{ output["roas"]["allServiceQuantity"] }}</td>
                    <td>{{ output["roas"]["allServiceCosts"] | priceLocaleString }}</td>
                    <td v-if="comparedTabList[1]">{{ output["roas"]["allServiceLastYearCosts"] | priceLocaleString }}
                    </td>


                    <!-- 自社(ROAS･売上･数量･広告費) -->
                    <template v-for="service in services.inHouses">
                        <td :key="`${service.id}-roas`">{{ maskRowRoas(monthOrday, output[service.id]["roas"]) | percentDisp }}</td>
                        <td :key="`${service.id}-earnings`" class="tooltipsHover" @mouseover="showTooltip($event)">
                            <div class="tooltipsPosition">
                                <template v-if="filteredEvents(monthOrday, service.id, service.services).length > 0">
                                    <div><span class="tooltipsIcon">■</span>
                                        <div class="tooltips">
                                            <div class="balloon_area" :style="balloonStyle">
                                                <div class="input-balloon">
                                                    <div class="balloon_flex">
                                                        <p class="baloon_item">
                                                            <template
                                                                v-for="event in filteredEvents(monthOrday, service.id, service.services)">
                                                                <span :key="event.id"><span
                                                                        style="font-weight: bold;">{{
                                                                            event.event_name
                                                                        }}</span><br>{{
                                                                            event.start_day + ' ' + event.start_time + ' ～ '
                                                                            +
                                                                            event.end_day + ' ' + event.end_time
                                                                        }}</span>
                                                            </template>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="filteredEvents(monthOrday, service.id, service.services).length == 0">
                                    <div></div>
                                </template>
                                <div>{{ output[service.id]["earnings"] | priceLocaleString }}</div>
                            </div>
                        </td>
                        <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                            {{ output[service.id]["lastYearEarnings"] | priceLocaleString }}
                        </td>
                        <td :key="`${service.id}-quantity`">{{ output[service.id]["quantity"] }}</td>
                        <td :key="`${service.id}-cost`">{{ output[service.id]["cost"] | priceLocaleString }}</td>
                        <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                            {{ output[service.id]["lastYearCost"] | priceLocaleString }}
                        </td>
                    </template>


                    <!-- モール(ROAS･売上･数量･広告費) -->
                    <template v-for="mallService in services.malls">
                        <!-- 楽天の場合、全店集計と各店舗集計をタブ切り替えで表示 -->
                        <template v-if="mallService.id == 'rakuten'">
                            <template v-if="!deploymented">
                                <td :key="`${mallService.id}-totalRoas`">{{ maskRowRoas(monthOrday, output[mallService.id]["totalRoas"]) | percentDisp }}
                                </td>
                                <td :key="`${mallService.id}-totalEarnings`" class="tooltipsHover"
                                    @mouseover="showTooltip($event)">
                                    <div class="tooltipsPosition">
                                        <template
                                            v-if="filteredEvents(monthOrday, mallService.id, mallService.services).length > 0">
                                            <div><span class="tooltipsIcon">■</span>
                                                <div class="tooltips">
                                                    <div class="balloon_area" :style="balloonStyle">
                                                        <div class="input-balloon">
                                                            <div class="balloon_flex">
                                                                <p class="baloon_item">
                                                                    <template
                                                                        v-for="event in filteredEvents(monthOrday, mallService.id, mallService.services)">
                                                                        <span :key="event.id"><span
                                                                                style="font-weight: bold;">{{
                                                                                    event.event_name
                                                                                }}</span><br>{{
                                                                                    event.start_day + ' ' + event.start_time +
                                                                                    '～ '
                                                                                    +
                                                                                    event.end_day + ' ' + event.end_time
                                                                                }}</span>
                                                                    </template>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template
                                            v-if="filteredEvents(monthOrday, mallService.id, mallService.services).length == 0">
                                            <div></div>
                                        </template>
                                        <div>{{ output[mallService.id]["totalEarnings"] | priceLocaleString }}</div>
                                    </div>
                                </td>
                                <td v-if="comparedTabList[mallService.no]"
                                    :key="`${mallService.id}-lastYearTotalEarnings`">
                                    {{ output[mallService.id]["lastYearTotalEarnings"] | priceLocaleString }}
                                </td>
                                <td :key="`${mallService.id}-totalQuantity`">
                                    {{ output[mallService.id]["totalQuantity"] }}
                                </td>
                                <td :key="`${mallService.id}-totalCost`">
                                    {{ output[mallService.id]["totalCost"] | priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[mallService.no]" :key="`${mallService.id}-lastYearTotalCost`">
                                    {{ output[mallService.id]["lastYearTotalCost"] | priceLocaleString }}
                                </td>
                            </template>
                            <template v-else>
                                <!-- 各店舗(ROAS･売上･数量･広告費) -->
                                <template v-for="service in mallService.services">
                                    <td :key="`${service.id}-roas`">{{ maskRowRoas(monthOrday, output[mallService.id][service.id]["roas"]) | percentDisp }}</td>
                                    <td :key="`${service.id}-earnings`" class="tooltipsHover"
                                        @mouseover="showTooltip($event)">
                                        <div class="tooltipsPosition">
                                            <template v-if="filteredEventsService(monthOrday, service.id).length > 0">
                                                <div><span class="tooltipsIcon">■</span>
                                                    <div class="tooltips">
                                                        <div class="balloon_area" :style="balloonStyle">
                                                            <div class="input-balloon">
                                                                <div class="balloon_flex">
                                                                    <p class="baloon_item">
                                                                        <template
                                                                            v-for="event in filteredEventsService(monthOrday, service.id)">
                                                                            <span :key="event.id"><span
                                                                                    style="font-weight: bold;">{{
                                                                                        event.event_name
                                                                                    }}</span><br>{{
                                                                                        event.start_day + ' ' + event.start_time
                                                                                        + ' ～ ' + event.end_day + ' ' +
                                                                                        event.end_time
                                                                                    }}</span>
                                                                        </template>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-if="filteredEventsService(monthOrday, service.id).length == 0">
                                                <div></div>
                                            </template>
                                            <div>{{ output[mallService.id][service.id]["earnings"] | priceLocaleString
                                            }}
                                            </div>
                                        </div>
                                    </td>
                                    <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                        {{ output[mallService.id][service.id]["lastYearEarnings"] | priceLocaleString }}
                                    </td>
                                    <td :key="`${service.id}-quantity`">
                                        {{ output[mallService.id][service.id]["quantity"] }}
                                    </td>
                                    <td :key="`${service.id}-cost`">
                                        {{ output[mallService.id][service.id]["cost"] | priceLocaleString }}
                                    </td>
                                    <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                        {{ output[mallService.id][service.id]["lastYearCost"] | priceLocaleString }}
                                    </td>
                                </template>
                            </template>
                        </template>
                        <!-- 楽天以外の場合 -->
                        <template v-else>
                            <template v-for="service in mallService.services">
                                <td :key="`${service.id}-roas`">{{ maskRowRoas(monthOrday, output[mallService.id][service.id]["roas"]) | percentDisp }}</td>
                                <td :key="`${service.id}-earnings`" class="tooltipsHover"
                                    @mouseover="showTooltip($event)">
                                    <div class="tooltipsPosition">
                                        <template v-if="filteredEventsService(monthOrday, service.id).length > 0">
                                            <div><span class="tooltipsIcon">■</span>
                                                <div class="tooltips">
                                                    <div class="balloon_area" :style="balloonStyle">
                                                        <div class="input-balloon">
                                                            <div class="balloon_flex">
                                                                <p class="baloon_item">
                                                                    <template
                                                                        v-for="event in filteredEventsService(monthOrday, service.id)">
                                                                        <span :key="event.id"><span
                                                                                style="font-weight: bold;">{{
                                                                                    event.event_name
                                                                                }}</span><br>{{
                                                                                    event.start_day + ' ' + event.start_time
                                                                                    + ' ～ ' + event.end_day + ' ' +
                                                                                    event.end_time
                                                                                }}</span>
                                                                    </template>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="filteredEventsService(monthOrday, service.id).length == 0">
                                            <div></div>
                                        </template>
                                        <div>{{ output[mallService.id][service.id]["earnings"] | priceLocaleString
                                        }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                    {{ output[mallService.id][service.id]["lastYearEarnings"] | priceLocaleString }}
                                </td>
                                <td :key="`${service.id}-quantity`">
                                    {{ output[mallService.id][service.id]["quantity"] }}
                                </td>
                                <td :key="`${service.id}-cost`">
                                    {{ output[mallService.id][service.id]["cost"] | priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                    {{ output[mallService.id][service.id]["lastYearCost"] | priceLocaleString }}
                                </td>
                            </template>
                        </template>
                    </template>

                    <!-- 店舗(ROAS･売上･数量･広告費) -->
                    <template v-for="shopService in filteredShops">
                        <template v-if="!deploymented">
                            <td :key="`${shopService.id}-totalRoas`">
                                {{ maskRowRoas(monthOrday, output[shopService.id]["totalRoas"]) | percentDisp }}
                            </td>
                            <td :key="`${shopService.id}-totalEarnings`">
                                {{ output[shopService.id]["totalEarnings"] | priceLocaleString }}
                            </td>
                            <td v-if="comparedTabList[shopService.no]" :key="`${shopService.id}-lastYearTotalEarnings`">
                                {{ output[shopService.id]["lastYearTotalEarnings"] | priceLocaleString }}
                            </td>
                            <td :key="`${shopService.id}-totalQuantity`">
                                {{ output[shopService.id]["totalQuantity"] }}
                            </td>
                            <td :key="`${shopService.id}-totalCost`">
                                {{ output[shopService.id]["totalCost"] | priceLocaleString }}
                            </td>
                            <td v-if="comparedTabList[shopService.no]" :key="`${shopService.id}-lastYearTotalCost`">
                                {{ output[shopService.id]["lastYearTotalCost"] | priceLocaleString }}
                            </td>
                        </template>
                        <template v-else>
                            <!-- 各店舗(ROAS･売上･数量･広告費) -->
                            <template v-for="service in shopService.services">
                                <td :key="`${service.id}-roas`">
                                    {{ maskRowRoas(monthOrday, output[shopService.id][service.id]["roas"]) | percentDisp }}</td>
                                <td :key="`${service.id}-earnings`">
                                    {{ output[shopService.id][service.id]["earnings"] | priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                    {{ output[shopService.id][service.id]["lastYearEarnings"] | priceLocaleString }}
                                </td>
                                <td :key="`${service.id}-quantity`">
                                    {{ output[shopService.id][service.id]["quantity"] }}
                                </td>
                                <td :key="`${service.id}-cost`">
                                    {{ output[shopService.id][service.id]["cost"] | priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                    {{ output[shopService.id][service.id]["lastYearCost"] | priceLocaleString }}
                                </td>
                            </template>
                        </template>
                    </template>
                </template>
            </tr>
        </tbody>
        <tfoot>
            <tr class="selectRoasRow total">
                <template>
                    <!-- 日付 -->
                    <td class="fixedTate dayField">合計</td>


                    <!-- 合計(ROAS･売上･数量･広告費) -->
                    <td>{{ maskTotalRoas(performanceReports['totalReports']["roas"]["allServiceRoas"]) | percentDisp }}</td>
                    <td v-if="roasTab">{{ maskTotalRoas(performanceReports['totalReports']["roas"]["ecServiceRoas"]) | percentDisp }}
                    </td>
                    <td>{{ performanceReports['totalReports']["roas"]["allServiceEarnings"] | priceLocaleString }}
                    </td>
                    <td v-if="comparedTabList[1]">{{
                        performanceReports['totalReports']["roas"]["allServiceLastYearEarnings"] |
                        priceLocaleString }}</td>
                    <td>{{ performanceReports['totalReports']["roas"]["allServiceQuantity"] }}</td>
                    <td>{{ performanceReports['totalReports']["roas"]["allServiceCosts"] | priceLocaleString }}</td>
                    <td v-if="comparedTabList[1]">{{
                        performanceReports['totalReports']["roas"]["allServiceLastYearCosts"] |
                        priceLocaleString }}</td>

                    <!-- 自社(ROAS･売上･数量･広告費) -->
                    <template v-for="service in services.inHouses">
                        <td :key="`${service.id}-roas`">{{ maskTotalRoas(performanceReports['totalReports'][service.id]["roas"]) | percentDisp }}</td>
                        <td :key="`${service.id}-earnings`">{{
                            performanceReports['totalReports'][service.id]["earnings"] |
                            priceLocaleString }}</td>
                        <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">{{
                            performanceReports['totalReports'][service.id]["lastYearEarnings"] |
                            priceLocaleString }}</td>
                        <td :key="`${service.id}-quantity`">{{
                            performanceReports['totalReports'][service.id]["quantity"] }}
                        </td>
                        <td :key="`${service.id}-cost`">{{ performanceReports['totalReports'][service.id]["cost"] |
                            priceLocaleString }}</td>
                        <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">{{
                            performanceReports['totalReports'][service.id]["lastYearCost"] |
                            priceLocaleString }}</td>
                    </template>


                    <!-- モール(ROAS･売上･数量･広告費) -->
                    <template v-for="mallService in services.malls">
                        <!-- 楽天の場合、全店集計と各店舗集計をタブ切り替えで表示 -->
                        <template v-if="mallService.id == 'rakuten'">
                            <template v-if="!deploymented">
                                <td :key="`${mallService.id}-totalRoas`">
                                    {{ maskTotalRoas(performanceReports['totalReports'][mallService.id]["totalRoas"]) | percentDisp }}
                                </td>
                                <td :key="`${mallService.id}-totalEarnings`">
                                    {{ performanceReports['totalReports'][mallService.id]["totalEarnings"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[mallService.no]"
                                    :key="`${mallService.id}-lastYrarTotalEarnings`">
                                    {{ performanceReports['totalReports'][mallService.id]["lastYearTotalEarnings"] |
                                        priceLocaleString }}
                                </td>
                                <td :key="`${mallService.id}-totalQuantity`">
                                    {{ performanceReports['totalReports'][mallService.id]["totalQuantity"] }}
                                </td>
                                <td :key="`${mallService.id}-totalCost`">
                                    {{ performanceReports['totalReports'][mallService.id]["totalCost"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[mallService.no]" :key="`${mallService.id}-lastYrarTotalCost`">
                                    {{ performanceReports['totalReports'][mallService.id]["lastYearTotalCost"] |
                                        priceLocaleString }}
                                </td>
                            </template>
                            <template v-else>
                                <!-- 各店舗(ROAS･売上･数量･広告費) -->
                                <template v-for="service in mallService.services">
                                    <td :key="`${service.id}-roas`">
                                        {{ maskTotalRoas(performanceReports['totalReports'][mallService.id][service.id]["roas"]) | percentDisp }}
                                    </td>
                                    <td :key="`${service.id}-earnings`">
                                        {{
                                            performanceReports['totalReports'][mallService.id][service.id]["earnings"] |
                                            priceLocaleString }}
                                    </td>
                                    <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                        {{
                                            performanceReports['totalReports'][mallService.id][service.id]["lastYearEarnings"]
                                            | priceLocaleString }}
                                    </td>
                                    <td :key="`${service.id}-quantity`">
                                        {{
                                            performanceReports['totalReports'][mallService.id][service.id]["quantity"]
                                        }}
                                    </td>
                                    <td :key="`${service.id}-cost`">
                                        {{ performanceReports['totalReports'][mallService.id][service.id]["cost"] |
                                            priceLocaleString }}
                                    </td>
                                    <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                        {{
                                            performanceReports['totalReports'][mallService.id][service.id]["lastYearCost"]
                                            |
                                            priceLocaleString }}
                                    </td>
                                </template>
                            </template>
                        </template>
                        <!-- 楽天以外の場合 -->
                        <template v-else>
                            <template v-for="service in mallService.services">
                                <td :key="`${service.id}-roas`">
                                    {{ maskTotalRoas(performanceReports['totalReports'][mallService.id][service.id]["roas"]) | percentDisp }}
                                </td>
                                <td :key="`${service.id}-earnings`">
                                    {{ performanceReports['totalReports'][mallService.id][service.id]["earnings"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                    {{
                                        performanceReports['totalReports'][mallService.id][service.id]["lastYearEarnings"]
                                        |
                                        priceLocaleString }}
                                </td>
                                <td :key="`${service.id}-quantity`">
                                    {{ performanceReports['totalReports'][mallService.id][service.id]["quantity"] }}
                                </td>
                                <td :key="`${service.id}-cost`">
                                    {{ performanceReports['totalReports'][mallService.id][service.id]["cost"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                    {{
                                        performanceReports['totalReports'][mallService.id][service.id]["lastYearCost"] |
                                        priceLocaleString }}
                                </td>
                            </template>
                        </template>
                    </template>

                    <!-- 店舗(ROAS･売上･数量･広告費) -->
                    <template v-for="shopService in filteredShops">
                        <template v-if="!deploymented">
                            <td :key="`${shopService.id}-totalRoas`">
                                {{ maskTotalRoas(performanceReports['totalReports'][shopService.id]["totalRoas"]) | percentDisp }}
                            </td>
                            <td :key="`${shopService.id}-totalEarnings`">
                                {{ performanceReports['totalReports'][shopService.id]["totalEarnings"] |
                                    priceLocaleString }}
                            </td>
                            <td v-if="comparedTabList[shopService.no]" :key="`${shopService.id}-lastYrarTotalEarnings`">
                                {{ performanceReports['totalReports'][shopService.id]["lastYearTotalEarnings"] |
                                    priceLocaleString }}
                            </td>
                            <td :key="`${shopService.id}-totalQuantity`">
                                {{ performanceReports['totalReports'][shopService.id]["totalQuantity"] }}
                            </td>
                            <td :key="`${shopService.id}-totalCost`">
                                {{ performanceReports['totalReports'][shopService.id]["totalCost"] |
                                    priceLocaleString }}
                            </td>
                            <td v-if="comparedTabList[shopService.no]" :key="`${shopService.id}-lastYrarTotalCost`">
                                {{ performanceReports['totalReports'][shopService.id]["lastYearTotalCost"] |
                                    priceLocaleString }}
                            </td>
                        </template>
                        <template v-else>
                            <!-- 各店舗(ROAS･売上･数量･広告費) -->
                            <template v-for="service in shopService.services">
                                <td :key="`${service.id}-roas`">
                                    {{ maskTotalRoas(performanceReports['totalReports'][shopService.id][service.id]["roas"]) | percentDisp }}
                                </td>
                                <td :key="`${service.id}-earnings`">
                                    {{
                                        performanceReports['totalReports'][shopService.id][service.id]["earnings"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearEarnings`">
                                    {{
                                        performanceReports['totalReports'][shopService.id][service.id]["lastYearEarnings"]
                                        | priceLocaleString }}
                                </td>
                                <td :key="`${service.id}-quantity`">
                                    {{
                                        performanceReports['totalReports'][shopService.id][service.id]["quantity"]
                                    }}
                                </td>
                                <td :key="`${service.id}-cost`">
                                    {{ performanceReports['totalReports'][shopService.id][service.id]["cost"] |
                                        priceLocaleString }}
                                </td>
                                <td v-if="comparedTabList[service.no]" :key="`${service.id}-lastYearCost`">
                                    {{
                                        performanceReports['totalReports'][shopService.id][service.id]["lastYearCost"]
                                        |
                                        priceLocaleString }}
                                </td>
                            </template>
                        </template>
                    </template>
                </template>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Datatable',
    data() {
        return {
            deploymented: false, //モールの各店舗表示切替タブ
            roasTab: false, //「EC ROAS」表示切替タブ
            reloaded: false,
            eventLists: [],
            balloonStyle: {
                top: '0px',
                left: '0px',
            },
            //前年比較表示切替タブ（services.jsのnoからcreatedで動的生成）
            comparedTabList: {},
            //各店舗のタイトル部分のcolspan設定値（services.jsのnoからcreatedで動的生成）
            serviceColList: {}
        }
    },
    props: {
        isOrderAsc: Boolean,
        isMonthly: Boolean,
        performanceReports: Object,
        dateUnit: String,
        startDate: String,
        endDate: Object,
        roasHiddenFrom: String, // この日以降の ROAS を「-」にする（Home の夜〜翌朝5時のみ）
    },
    mounted: function () {
        this.getEvents();
    },
    watch: {
        //店舗一覧が（非同期で）変わったらタブ・colspan設定を組み直す
        services: {
            handler: function () {
                this.initServiceTabs();
            },
            immediate: true,
        },
    },
    methods: {
        // 広告費がまだ入っていない日（roasHiddenFrom 以降）の ROAS を「-」にする
        // 当日分の売上は夜の集計で入るが、広告費は翌朝4時の取込で入るため、そのままだと極端な値になる
        maskRowRoas(key, value) {
            return this.isRoasHiddenRow(key) ? '-' : value;
        },
        // 合計行は、広告費の無い日を期間に含むと高めに出るため「-」にする
        maskTotalRoas(value) {
            return this.roasHiddenFrom ? '-' : value;
        },
        isRoasHiddenRow(key) {
            if (!this.roasHiddenFrom) {
                return false;
            }
            if (this.dateUnit === 'day') {
                return key >= this.roasHiddenFrom;
            }
            // 週・月の単位では、広告費の無い日（期間の最終日）を含む最後の行
            const keys = Object.keys(this.performanceReports.outputs || {});
            return String(key) === keys[keys.length - 1];
        },
        //services.jsの全サービスのnoから、前年比較タブ・colspan設定を動的生成する
        //（店舗をservices.jsで増減してもハードコードを修正せず追従させるため）
        initServiceTabs: function () {
            const comparedTabList = {};
            const serviceColList = {};

            const register = (no) => {
                if (no === undefined || no === null) {
                    return;
                }
                comparedTabList[no] = false;
                serviceColList[no] = 4;
            };

            register(1); //合計
            this.services.inHouses.forEach(inHouse => register(inHouse.no));
            this.services.malls.forEach(mall => {
                register(mall.no);
                mall.services.forEach(service => register(service.no));
            });
            this.services.shops.forEach(shop => {
                register(shop.no);
                shop.services.forEach(service => register(service.no));
            });

            this.comparedTabList = comparedTabList;
            this.serviceColList = serviceColList;
        },
        getEvents: function () {
            var url = "/api/productRoasBySites/events";

            const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
            const searchEndedAt = (this.endDate < yesterday) ? this.endDate : yesterday;
            const searchEndedDate = searchEndedAt.format('YYYY-MM-DD');

            this.axios.get(url, {
                params: {
                    start_date: this.startDate,
                    end_date: searchEndedDate,
                }
            })
                .then((res) => {
                    this.eventLists = res.data;
                }).catch(() => {
                }).finally(() => {
                });
        },
        filteredEvents(monthOrday, serviceName, services) {
            var start = monthOrday;
            var end = monthOrday;

            //月次表示の場合
            if (monthOrday.length == 7) {
                start = monthOrday + "-01";

                if (monthOrday.slice(-2) === "04" || monthOrday.slice(-2) === "06" || monthOrday.slice(-2) === "09" || monthOrday.slice(-2) === "11") {
                    end = monthOrday + "-30";
                }
                else if (monthOrday.slice(-2) === "02") {
                    var year = monthOrday.slice(0, 4);

                    //うるう年判定
                    //4で割り切れるかつ100で割り切れない
                    //4で割り切れるかつ100で割り切れるかつ400で割り切れる
                    if (year % 4 == 0) {
                        if (year % 100 == 0) {
                            if (year % 400 == 0) {
                                end = monthOrday + "-29";
                            }
                            else {
                                end = monthOrday + "-28";
                            }
                        }
                        else {
                            end = monthOrday + "-29";
                        }
                    }
                    else {
                        end = monthOrday + "-28";
                    }
                }
                else {
                    end = monthOrday + "-31";
                }
            }

            //週次の場合
            else if (monthOrday.length >= 7) {
                start = monthOrday.slice(0, 10);
                end = monthOrday.slice(-10);
            }

            let serviceId = [];
            services.forEach(service => {
                serviceId.push(service.id)
            });

            if (serviceName == "rakuten") {
                serviceId.push("");
            }
            return this.eventLists.filter(event => {
                const isInMonthOrDayRange = event.start_day <= end && event.end_day >= start;
                const isServiceIncluded = serviceId.includes(event.service_code);
                return isInMonthOrDayRange && isServiceIncluded;
            });
        },
        filteredEventsService(monthOrday, services) {
            var start = monthOrday;
            var end = monthOrday;

            //月次表示の場合
            if (monthOrday.length == 7) {
                start = monthOrday + "-01";

                if (monthOrday.slice(-2) === "04" || monthOrday.slice(-2) === "06" || monthOrday.slice(-2) === "09" || monthOrday.slice(-2) === "11") {
                    end = monthOrday + "-30";
                }
                else if (monthOrday.slice(-2) === "02") {
                    var year = monthOrday.slice(0, 4);

                    //うるう年判定
                    //4で割り切れるかつ100で割り切れない
                    //4で割り切れるかつ100で割り切れるかつ400で割り切れる
                    if (year % 4 == 0) {
                        if (year % 100 == 0) {
                            if (year % 400 == 0) {
                                end = monthOrday + "-29";
                            }
                            else {
                                end = monthOrday + "-28";
                            }
                        }
                        else {
                            end = monthOrday + "-29";
                        }
                    }
                    else {
                        end = monthOrday + "-28";
                    }
                }
                else {
                    end = monthOrday + "-31";
                }
            }

            //週次の場合
            else if (monthOrday.length >= 7) {
                start = monthOrday.slice(0, 10);
                end = monthOrday.slice(-10);
            }

            let rakutenCode = ["r-amepla", "r-nelture", "r-seitai"];
            return this.eventLists.filter(event => {
                const isInMonthOrDayRange = event.start_day <= end && event.end_day >= start;
                let isServiceIncluded = event.service_code == services;

                if (!isServiceIncluded) {
                    isServiceIncluded = event.service_code == "" && rakutenCode.includes(services);
                }
                return isInMonthOrDayRange && isServiceIncluded;
            });
        },
        showTooltip(event) {
            // 吹き出しの位置を計算
            const tooltipX = event.clientX;
            const tooltipY = event.clientY + 10;

            this.balloonStyle = {
                top: `${tooltipY}px`,
                left: `${tooltipX}px`,
            };
        },
        //モールの各店舗表示切替タブ
        deploymentedDisp() {
            //展開中の場合
            if (this.deploymented) {
                //閉じる
                this.deploymented = false
            } else {
                //開く
                this.deploymented = true
            }

            //前年比のタブ切り替えリセット
            Object.keys(this.comparedTabList).forEach(key => {
                this.comparedTabList[key] = false;
                this.serviceColList[key] = 4;

                if (key == 1) {
                    if (this.roasTab) {
                        this.serviceColList[key] = 5;
                    }
                    else {
                        this.serviceColList[key] = 4;
                    }
                }
            });
        },
        //ROAS表示切替タブ
        roasDisp(index) {
            if (this.roasTab) {
                this.roasTab = false;
                if (this.comparedTabList[index]) {
                    this.serviceColList[index] = 6;
                }
                else {
                    this.serviceColList[index] = 4;
                }
            }
            else {
                this.roasTab = true;
                if (this.comparedTabList[index]) {
                    this.serviceColList[index] = 7;
                }
                else {
                    this.serviceColList[index] = 5;
                }
            }
        },
        //前年比較表示切替タブ
        comparedDisp(idx) {
            if (idx != 1) {
                if (this.comparedTabList[idx]) {
                    this.comparedTabList[idx] = false;
                    this.serviceColList[idx] = 4;
                }
                else {
                    this.comparedTabList[idx] = true;
                    this.serviceColList[idx] = 6;
                }
            }
            else {
                if (this.comparedTabList[idx]) {
                    this.comparedTabList[idx] = false;
                    if (this.roasTab) {
                        this.serviceColList[idx] = 5;
                    }
                    else {
                        this.serviceColList[idx] = 4;
                    }
                }
                else {
                    this.comparedTabList[idx] = true;
                    if (this.roasTab) {
                        this.serviceColList[idx] = 7;
                    }
                    else {
                        this.serviceColList[idx] = 6;
                    }
                }
            }
        },
        rowClosingMonthStartDateClass(date) {
            if (!date.match(this.reportStatus.isMonthlyGrouped ? /^\d+-12/ : /^\d+-12-01/)) {
                return;
            }
            return {
                closingMonthStartDateRow: true,
                isOrderAsc: this.isOrderAsc,
            };
        },
        dayFieldColorClass(date) {
            if (this.isMonthly) {
                return;
            }

            if (this.holidaysFind(date)) {
                return 'isHoliday';
            }
            // day: (Sunday as 0, Saturday as 6)
            const week = this.$dayjs(date).get('day');

            if (week == 0) {
                return 'isSunday';
            } else if (week == 6) {
                return 'isSaturday';
            } else {
                return null;
            }
        },
    },
    computed: {
        serviceNoOrder: function () {
            const list = [1]; // 合計
            this.services.inHouses.forEach(s => list.push(s.no));
            this.services.malls.forEach(mall => {
                if (mall.id === 'rakuten') {
                    if (this.deploymented) {
                        mall.services.forEach(s => list.push(s.no));
                    } else {
                        list.push(mall.no);
                    }
                } else {
                    // yahoo/amazon/zozoはmall自身に.noが無く、service側に定義されている
                    mall.services.forEach(s => list.push(s.no));
                }
            });
            this.filteredShops.forEach(shopGroup => {
                if (this.deploymented) {
                    shopGroup.services.forEach(s => list.push(s.no));
                } else {
                    list.push(shopGroup.no);
                }
            });
            return list;
        },
        // 店舗のうち、売上と数量がどちらも0のものを描画対象から除外
        filteredShops: function () {
            const shopTotals =
                (this.performanceReports
                    && this.performanceReports.totalReports
                    && this.performanceReports.totalReports.shop) || {};
            return this.services.shops.map(shopService => ({
                ...shopService,
                services: shopService.services.filter(service => {
                    const data = shopTotals[service.id];
                    if (!data) return true;
                    return !(data.earnings === 0 && data.quantity === 0);
                }),
            }));
        },
        // データを表示させる表の列数(展開･非展開時)
        deploymentedCount: function () {
            if (this.deploymented) {
                // 表を展開させた時
                const mallCount = this.services.malls
                    .map(services => services.services.length)
                    .reduce((previousValue, currentValue) => previousValue + currentValue)
                const shopCount = this.filteredShops.map(services => services.services.length)
                    .reduce((previousValue, currentValue) => previousValue + currentValue)
                // +1 :合計カラム
                return this.services.inHouses.length + mallCount + shopCount + 1
            } else {
                // 表を展開させなかった時
                // +1 :合計カラム
                return this.services.inHouses.length + this.services.malls.length + this.filteredShops.length + 1
            }
        },
        dispReports: function () {
            if (this.isOrderAsc) {
                return this.performanceReports.outputs
            } else {
                const outputs = Object.entries(this.performanceReports.outputs).slice().reverse();
                return Object.fromEntries(outputs);
            }
        },
        ...mapGetters({
            services: 'services/allByGroup',
            holidaysFind: 'holidays/find',
        }),
    },
}
</script>

<style scoped lang="sass">
#siteTable
    border-collapse: separate
    margin: 0px auto
    white-space: nowrap
    th
        background: $grayColor
        border: 1px solid #bbb
        color: $whiteColor
        padding: 10px 5px
        text-align: left
        top: 0
        vertical-align: middle
    .editCol
        background: $mainColor
    tbody
        tr
            background: $whiteColor
        tr:nth-child(odd)
            background: #eee
    tfoot
        tr
            position: sticky
            bottom: 0
            z-index: 3
            background: $whiteColor
    tr, tr:nth-child(odd)
        &:hover
            background-color: #c8f0e8
.tooltips
    position: absolute
    visibility: hidden
    opacity: 0
    z-index: 1000
.tooltipsHover
    &:hover .tooltips
        visibility: visible
        opacity: 1
        transition: .3s
.tooltipsPosition
    display: flex;
    justify-content: space-between;
    position: relative;
.tooltipsIcon
    margin-left: 3px
    text-align: center
    color: red
    font-weight: bold
.balloon_area
    position: fixed
    left: 50%
    top: 0
    transform: translateX(15%) translateY(-95%)
    color : #000
    text-align: left
    .input-balloon
        position: relative
        padding: 5px
        background: #fff
        border: 1px solid #fff
        border-radius: 5px
        filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, .5));
        color: $grayColor
        &::before
            content: "";
            position: absolute;
            bottom: 2%;
            left: -8%;
            width: 0;
            height: 0;
            border: 15px solid transparent;
            border-right-color: #fff;
        .baloon_item
            display: flex
            justify-content: space-between
            margin: 0 5px
            flex-direction: column
            span
                padding: 8px 0;
            span:not(:first-child)
                border-top: 1px solid #ccc;
                display: block;
.fixedTate, .fixedYoko
    background: inherit
    left: 0
    position: sticky
    // transition: all .2s ease-in-out
    z-index: 1
.fixedYokoTwo
    background: $whiteColor
    left: 0
    position: sticky
    top: 36px !important
    transition: all .2s ease-in-out
    z-index: 1
    .header-label
        display: flex;
        justify-content: space-between;
.fixedYokoTwo_s
    top: 37px !important
.fixedYokoThree
    top: 72px !important
.fixedTateYoko
    left: 0
    position: sticky
    top: 0
    z-index: 2
.selectRoasRow
    color: $grayColor
    position: relative
    td
        border: 1px solid #bbb
        padding: 5px
        text-align: right
    .dayField
        text-align: left
        &.isHoliday, &.isSunday
            color: #f55
        &.isSaturday
            color: #55f
    .editCell
        cursor: pointer
        padding: 0
        position: relative
    .editCellText
        border: 1px solid $mainColor
        padding: 5px
        width: 100%
    &.closingMonthStartDateRow:not(.isOrderAsc) td
        border-bottom: 1px solid $mainColor
    &.closingMonthStartDateRow.isOrderAsc td
        border-top: 1px solid $mainColor
    &.total
        td
            border-top: 2px solid $grayColor
        .dayField
            text-align: center
.selectRoasRowTransition-enter
    transform: translateX(100px)
    opacity: 0
.selectRoasRowTransition-enter-active
    transition: all 500ms linear var(--transition-delay)
.shrinkBtn
    background: #444
    border: 1px solid #fff
    cursor: pointer
    display: block
    float: right
    height: 15px
    overflow: hidden
    position: relative
    width: 30px
    &::before
        background: #00ad90
        content: ''
        height: 13px
        position: absolute
        right: 0
        top: 0
        transform: translateX(75%)
        transition: all .3s ease-in-out
        width: 30px
    &::after
        border-bottom: 1px solid #fff
        border-right: 1px solid #fff
        content: ''
        display: block
        height: 5px
        position: absolute
        right: 12px
        top: 50%
        transform: rotate(135deg) translateY(-50%)
        transition: all .4s ease-in-out
        transform-origin: 50% 0
        width: 5px
    &:hover
        &::before
            transform: translateX(0%)
</style>
